import { FormPayload } from '../types';
import { getBaseHostUrl } from '../../../../Utils/URL/Hosts/BaseHostUtils';
import { getAuthTokenStorage } from '../../../../Utils/Auth';

export const toSignInAPI = (payload: FormPayload) => {
  return fetch(`${getBaseHostUrl()}/api/auth/sign-in`, {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    body: JSON.stringify(payload),
  }).then(r => {
    if (r.status === 401) {
      throw r;
    }
    if (r.status === 422) {
      const text = () => Promise.resolve('Incorrect login or password');

      // eslint-disable-next-line no-throw-literal
      throw {
        status: 422,
        text: text,
      };
    }
    return r.json();
  });
};

export const refreshTokenAPI = (
  token: string,
  { signal }: { signal?: AbortSignal },
) => {
  return fetch(`${getBaseHostUrl()}/api/auth/refresh-token`, {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: getAuthTokenStorage(),
    },
    signal,
  }).then(r => {
    if (r.status === 401) {
      throw r;
    }
    return r.json();
  });
};
